/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { EduContentMetadataInterface, GoalTopicInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class GoalTopicApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'GoalTopics');
  }

  create(goalTopic: GoalTopicInterface): Observable<GoalTopicInterface> {
    const path = '';
    return this.post<GoalTopicInterface>(path, undefined, goalTopic);
  }

  deleteById(goalTopicId: number): Observable<boolean> {
    const path = `${goalTopicId}`;
    return this.delete(path).pipe(map(() => true));
  }

  getGoalsForLearningArea(learningAreaId: number, includeGoals = false): Observable<GoalTopicInterface[]> {
    const path = `learning-area/${learningAreaId}`;
    const httpParams = this._getHttpParams({ includeGoals });
    return this.get<GoalTopicInterface[]>(path, httpParams);
  }

  getLinkedEduContentMetadata(goalTopicId: number): Observable<EduContentMetadataInterface[]> {
    const path = `${goalTopicId}/edu-content-metadata`;
    return this.get<EduContentMetadataInterface[]>(path, undefined);
  }

  patchAttributes(goalTopicId: number, updates: Partial<GoalTopicInterface>): Observable<GoalTopicInterface> {
    const path = `${goalTopicId}`;
    return this.patch<GoalTopicInterface>(path, undefined, updates);
  }
}
